(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './core-core-api.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./core-core-api.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'core-core-kernel'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'core-core-kernel'.");
    }
    if (typeof this['core-core-api'] === 'undefined') {
      throw new Error("Error loading module 'core-core-kernel'. Its dependency 'core-core-api' was not found. Please, check whether 'core-core-api' is loaded prior to 'core-core-kernel'.");
    }
    root['core-core-kernel'] = factory(typeof this['core-core-kernel'] === 'undefined' ? {} : this['core-core-kernel'], this['kotlin-kotlin-stdlib'], this['core-core-api']);
  }
}(this, function (_, kotlin_kotlin, kotlin_core_core_api) {
  'use strict';
  //region block: imports
  var protoOf = kotlin_kotlin.$_$.u9;
  var CoreFactory = kotlin_core_core_api.$_$.a;
  var classMeta = kotlin_kotlin.$_$.q8;
  var setMetadataFor = kotlin_kotlin.$_$.v9;
  var VOID = kotlin_kotlin.$_$.e;
  var EntityManagerImpl = kotlin_core_core_api.$_$.y2;
  var HierarchySystem = kotlin_core_core_api.$_$.l3;
  var ComponentDeserializerRegistry = kotlin_core_core_api.$_$.h6;
  var JsonSerializer = kotlin_core_core_api.$_$.k6;
  var SnapshotService = kotlin_core_core_api.$_$.f7;
  var CoreServices = kotlin_core_core_api.$_$.c;
  var TransformSystem = kotlin_core_core_api.$_$.h7;
  var WorldColliderUpdateSystem = kotlin_core_core_api.$_$.b1;
  var WorldDragSurfaceUpdateSystem = kotlin_core_core_api.$_$.t2;
  var RenderSystem = kotlin_core_core_api.$_$.r5;
  var ConnectionParentingSystem = kotlin_core_core_api.$_$.k3;
  var UpdateHostConnectionsSystem = kotlin_core_core_api.$_$.o1;
  var SceneGraphSystem = kotlin_core_core_api.$_$.n3;
  var DisableConnectorsSystem = kotlin_core_core_api.$_$.w1;
  var ViewerObjectTransformSystem = kotlin_core_core_api.$_$.v5;
  var ViewerPresenceSystem = kotlin_core_core_api.$_$.x5;
  var ViewerObjectVisibilitySystem = kotlin_core_core_api.$_$.w5;
  var CollisionValidation = kotlin_core_core_api.$_$.a1;
  var Unit_instance = kotlin_kotlin.$_$.x3;
  var LoggerImpl = kotlin_core_core_api.$_$.p4;
  var LoggerState_getInstance = kotlin_core_core_api.$_$.fb;
  var setLogModule = kotlin_core_core_api.$_$.q8;
  var LogLevel_DEBUG_getInstance = kotlin_core_core_api.$_$.a8;
  var LogLevel_INFO_getInstance = kotlin_core_core_api.$_$.c8;
  var LogLevel_WARN_getInstance = kotlin_core_core_api.$_$.d8;
  var LogLevel_ERROR_getInstance = kotlin_core_core_api.$_$.b8;
  var HistoryImpl = kotlin_core_core_api.$_$.l4;
  var addHistoryModule = kotlin_core_core_api.$_$.p8;
  var ViewerComponent = kotlin_core_core_api.$_$.s5;
  var ComponentIds_instance = kotlin_core_core_api.$_$.w9;
  var getCoreVersion = kotlin_core_core_api.$_$.p7;
  var defineProp = kotlin_kotlin.$_$.s8;
  var Core = kotlin_core_core_api.$_$.d;
  var CoreModules = kotlin_core_core_api.$_$.b;
  var asSequence = kotlin_kotlin.$_$.t4;
  var mapNotNull = kotlin_kotlin.$_$.ya;
  var firstOrNull = kotlin_kotlin.$_$.va;
  var ProductComponent = kotlin_core_core_api.$_$.q;
  var SnapRootComponent = kotlin_core_core_api.$_$.z6;
  var get_isConnectionRoot = kotlin_core_core_api.$_$.t1;
  var RelativeConnectorRepositioner_instance = kotlin_core_core_api.$_$.ja;
  var Companion_instance = kotlin_core_core_api.$_$.l9;
  var Companion_getInstance = kotlin_core_core_api.$_$.k9;
  var Companion_instance_0 = kotlin_core_core_api.$_$.j9;
  var Companion_instance_1 = kotlin_core_core_api.$_$.i9;
  var AssemblyPart = kotlin_core_core_api.$_$.h;
  var Companion_instance_2 = kotlin_core_core_api.$_$.q9;
  var Companion_getInstance_0 = kotlin_core_core_api.$_$.p9;
  var equals = kotlin_kotlin.$_$.t8;
  var objectMeta = kotlin_kotlin.$_$.t9;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.h;
  var copyToArray = kotlin_kotlin.$_$.l5;
  var toString = kotlin_kotlin.$_$.z9;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.f1;
  var createEntity = kotlin_core_core_api.$_$.s8;
  var ChildComponent = kotlin_core_core_api.$_$.j3;
  var createEntityInternal = kotlin_core_core_api.$_$.r8;
  var get_productRef = kotlin_core_core_api.$_$.w;
  var createFromSpecification = kotlin_core_core_api.$_$.u8;
  var createFromSpecificationInternal = kotlin_core_core_api.$_$.t8;
  var ProductManager = kotlin_core_core_api.$_$.r;
  var repeat = kotlin_kotlin.$_$.rb;
  var SystemBase2 = kotlin_core_core_api.$_$.a3;
  var InSceneComponent_instance = kotlin_core_core_api.$_$.ab;
  var Companion_instance_3 = kotlin_core_core_api.$_$.xc;
  var hashCode = kotlin_kotlin.$_$.a9;
  var THROW_CCE = kotlin_kotlin.$_$.ad;
  var get_serializable = kotlin_core_core_api.$_$.w2;
  var Component = kotlin_core_core_api.$_$.x2;
  var DisplayNameComponent = kotlin_core_core_api.$_$.e5;
  var ParentComponent = kotlin_core_core_api.$_$.m3;
  var StaticComponent_getInstance = kotlin_core_core_api.$_$.wa;
  var first = kotlin_kotlin.$_$.w5;
  var HierarchyUtils_instance = kotlin_core_core_api.$_$.za;
  var SceneComponent_instance = kotlin_core_core_api.$_$.bb;
  var get_children = kotlin_core_core_api.$_$.p3;
  var get_parentComponent = kotlin_core_core_api.$_$.g4;
  var get_hierarchy = kotlin_core_core_api.$_$.x3;
  var SceneReloadingComponent_instance = kotlin_core_core_api.$_$.nc;
  var SceneManager = kotlin_core_core_api.$_$.o3;
  var firstOrNull_0 = kotlin_kotlin.$_$.u5;
  var Companion_instance_4 = kotlin_core_core_api.$_$.o9;
  var first_0 = kotlin_kotlin.$_$.v5;
  var get_parent = kotlin_core_core_api.$_$.f4;
  var get_descendants = kotlin_core_core_api.$_$.q3;
  var Companion_getInstance_1 = kotlin_core_core_api.$_$.ad;
  var Companion_getInstance_2 = kotlin_core_core_api.$_$.dd;
  var Companion_getInstance_3 = kotlin_core_core_api.$_$.ta;
  var Companion_getInstance_4 = kotlin_core_core_api.$_$.va;
  var Companion_getInstance_5 = kotlin_core_core_api.$_$.m9;
  var Companion_getInstance_6 = kotlin_core_core_api.$_$.oc;
  var to = kotlin_kotlin.$_$.be;
  var mapOf = kotlin_kotlin.$_$.s6;
  var ComponentDeserializer = kotlin_core_core_api.$_$.i6;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.v4;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.g;
  var checkIndexOverflow = kotlin_kotlin.$_$.u4;
  var lazy = kotlin_kotlin.$_$.wd;
  var ValidationResultType_FAIL_getInstance = kotlin_core_core_api.$_$.n8;
  var filterNotNull = kotlin_kotlin.$_$.s5;
  var KProperty0 = kotlin_kotlin.$_$.ma;
  var THROW_ISE = kotlin_kotlin.$_$.cd;
  var getLocalDelegateReference = kotlin_kotlin.$_$.w8;
  var toMutableList = kotlin_kotlin.$_$.y7;
  var minus = kotlin_kotlin.$_$.t6;
  var validateSnap = kotlin_core_core_api.$_$.a9;
  var toList = kotlin_kotlin.$_$.v7;
  var addAll = kotlin_kotlin.$_$.m4;
  var validateSnaps = kotlin_core_core_api.$_$.z8;
  var validateCurrentState = kotlin_core_core_api.$_$.y8;
  var ValidSnapActionCandidateOrErrors = kotlin_core_core_api.$_$.s7;
  var ValidationResultType_WARNING_getInstance = kotlin_core_core_api.$_$.o8;
  var ensureNotNull = kotlin_kotlin.$_$.qd;
  var lastOrNull = kotlin_kotlin.$_$.k6;
  var getFirstValidSnapAction = kotlin_core_core_api.$_$.x8;
  var evaluateSnapCandidate = kotlin_core_core_api.$_$.w8;
  var evaluateSnapCandidates = kotlin_core_core_api.$_$.v8;
  var ValidationService = kotlin_core_core_api.$_$.x7;
  var Companion_getInstance_7 = kotlin_core_core_api.$_$.tb;
  var ClickEventComponent = kotlin_core_core_api.$_$.e6;
  //endregion
  //region block: pre-declaration
  setMetadataFor(CoreFactoryImpl, 'CoreFactoryImpl', classMeta, VOID, [CoreFactory], CoreFactoryImpl);
  setMetadataFor(CoreImpl, 'CoreImpl', classMeta, VOID, [Core], CoreImpl);
  setMetadataFor(CoreModulesImpl, 'CoreModulesImpl', classMeta, VOID, [CoreModules]);
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor(ProductManagerImpl, 'ProductManagerImpl', classMeta, VOID, [ProductManager]);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor(SystemGraphViewer, 'SystemGraphViewer', classMeta);
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor(SceneManagerCacheClearingSystem, 'SceneManagerCacheClearingSystem', classMeta, SystemBase2);
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor(SceneManagerCacheComponent, 'SceneManagerCacheComponent', classMeta, VOID, [Component]);
  setMetadataFor(SceneManagerEntitiesCache, 'SceneManagerEntitiesCache', classMeta);
  setMetadataFor(Companion_3, 'Companion', objectMeta);
  setMetadataFor(SceneManagerImpl, 'SceneManagerImpl', classMeta, VOID, [SceneManager]);
  setMetadataFor(SceneSerializationUtil, 'SceneSerializationUtil', objectMeta);
  setMetadataFor(CoreComponentDeserializer, 'CoreComponentDeserializer', classMeta, VOID, [ComponentDeserializer], CoreComponentDeserializer);
  setMetadataFor(ValidationServiceImpl, 'ValidationServiceImpl', classMeta, VOID, [ValidationService], ValidationServiceImpl);
  //endregion
  function CoreFactoryImpl() {
  }
  protoOf(CoreFactoryImpl).createNewCoreInstance = function () {
    return new CoreImpl();
  };
  function CoreImpl$lambda($sceneManager) {
    return function () {
      return $sceneManager.scene;
    };
  }
  function CoreImpl(initialSceneManager, validationService, entityManager) {
    initialSceneManager = initialSceneManager === VOID ? null : initialSceneManager;
    validationService = validationService === VOID ? new ValidationServiceImpl() : validationService;
    entityManager = entityManager === VOID ? new EntityManagerImpl() : entityManager;
    entityManager.registerSystem(new HierarchySystem(entityManager));
    var sceneManager = initialSceneManager == null ? new SceneManagerImpl(entityManager) : initialSceneManager;
    this.h2u_1 = new CoreModulesImpl(sceneManager);
    var componentSerializationRegistry = new ComponentDeserializerRegistry();
    var productManager = new ProductManagerImpl(entityManager, CoreImpl$lambda(sceneManager));
    var serializer = new JsonSerializer(productManager);
    var coreFactory = new CoreFactoryImpl();
    var snapshotService = new SnapshotService(entityManager, sceneManager);
    this.g2u_1 = new CoreServices(this.modules, entityManager, sceneManager, componentSerializationRegistry, validationService, serializer, productManager, snapshotService, coreFactory);
    entityManager.registerSystem(new TransformSystem());
    entityManager.registerSystem(new WorldColliderUpdateSystem());
    entityManager.registerSystem(new WorldDragSurfaceUpdateSystem());
    entityManager.registerSystem(new RenderSystem());
    entityManager.registerSystem(new ConnectionParentingSystem());
    entityManager.registerSystem(new UpdateHostConnectionsSystem());
    entityManager.registerSystem(new SceneGraphSystem(sceneManager));
    entityManager.registerSystem(new DisableConnectorsSystem());
    this.g2u_1.componentDeserializerRegistry.register(new CoreComponentDeserializer());
    entityManager.registerSystem(new ViewerObjectTransformSystem());
    entityManager.registerSystem(new ViewerPresenceSystem(entityManager));
    entityManager.registerSystem(new ViewerObjectVisibilitySystem());
    this.addValidation(new CollisionValidation());
  }
  protoOf(CoreImpl).m1i = function () {
    return this.g2u_1;
  };
  protoOf(CoreImpl).n1i = function () {
    return this.h2u_1;
  };
  protoOf(CoreImpl).addValidation = function (validation) {
    this.g2u_1.validations.register(validation);
  };
  protoOf(CoreImpl).removeValidation = function (validation) {
    this.g2u_1.validations.unregister(validation);
  };
  protoOf(CoreImpl).getValidations = function () {
    return this.g2u_1.validations.validations;
  };
  protoOf(CoreImpl).k1i = function (logger, basePackageName) {
    var nonNullLogger = logger == null ? new LoggerImpl() : logger;
    var tmp = LoggerState_getInstance();
    tmp.k2b(nonNullLogger, basePackageName == null ? '' : basePackageName);
  };
  protoOf(CoreImpl).setLogLevel = function (level) {
    // Inline function 'kotlin.text.uppercase' call
    // Inline function 'kotlin.js.asDynamic' call
    switch (level.toUpperCase()) {
      case 'DEBUG':
        LoggerState_getInstance().j2b(LogLevel_DEBUG_getInstance());
        break;
      case 'INFO':
        LoggerState_getInstance().j2b(LogLevel_INFO_getInstance());
        break;
      case 'WARN':
        LoggerState_getInstance().j2b(LogLevel_WARN_getInstance());
        break;
      case 'ERROR':
        LoggerState_getInstance().j2b(LogLevel_ERROR_getInstance());
        break;
      default:
        LoggerState_getInstance().j2b(LogLevel_INFO_getInstance());
        break;
    }
  };
  protoOf(CoreImpl).l1i = function (history, historySize) {
    var nonNullHistory = history == null ? new HistoryImpl(this.g2u_1.entityManager, this.g2u_1.snapshotService, historySize) : history;
    this.h2u_1.setHistory(nonNullHistory);
    return nonNullHistory;
  };
  protoOf(CoreImpl).setViewer = function (viewer) {
    var sceneRoot = this.g2u_1.sceneManager.root;
    if (viewer == null) {
      this.g2u_1.entityManager.removeComponent(sceneRoot, 82);
    } else {
      this.g2u_1.entityManager.addComponent(sceneRoot, new ViewerComponent(viewer));
    }
  };
  protoOf(CoreImpl).version = function () {
    return getCoreVersion();
  };
  function CoreModulesImpl(sceneManager) {
    this.sceneManager = sceneManager;
    this.i2u_1 = null;
  }
  protoOf(CoreModulesImpl).q1i = function () {
    return this.sceneManager;
  };
  protoOf(CoreModulesImpl).history = function () {
    return this.i2u_1;
  };
  protoOf(CoreModulesImpl).viewer = function () {
    var tmp0_safe_receiver = this.sceneManager;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.root;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = tmp1_safe_receiver.__getComponentForKotlin(82);
    }
    var tmp2_safe_receiver = tmp;
    return tmp2_safe_receiver == null ? null : tmp2_safe_receiver.viewer;
  };
  protoOf(CoreModulesImpl).setHistory = function (history) {
    this.i2u_1 = history;
  };
  function findProductSpecification($this, productRef) {
    var tmp = asSequence($this.catalogs);
    return firstOrNull(mapNotNull(tmp, ProductManagerImpl$findProductSpecification$lambda(productRef)));
  }
  function createEntityFromSpecification($this, specification, productRef, entityId) {
    var entity = entityId == null ? $this.j2u_1.createEntity() : $this.j2u_1.createEntityInternal(entityId);
    $this.j2u_1.addComponent(entity, new ProductComponent(productRef));
    addComponents($this, entity, specification.components);
    if (get_isConnectionRoot(entity)) {
      addComponent($this, entity, new SnapRootComponent());
    }
    buildAssembly($this, specification, entity, productRef);
    var newRoot = buildHierarchy($this, specification, entity);
    if (!(newRoot == null)) {
      RelativeConnectorRepositioner_instance.repositionRelativeConnectorsFromBounds(newRoot);
    }
    return newRoot;
  }
  function createEntityFromSpecification$default($this, specification, productRef, entityId, $super) {
    entityId = entityId === VOID ? null : entityId;
    return createEntityFromSpecification($this, specification, productRef, entityId);
  }
  function buildAssembly($this, specification, entity, productRef) {
    var structure = specification._findComponentKt(12);
    Companion_getInstance();
    var parts = specification._findComponentKt(43);
    var assemblyEntityIds = specification._findComponentKt(96);
    if (structure == null ? true : parts == null) {
      return Unit_instance;
    }
    addComponent($this, entity, structure);
    Companion_getInstance();
    entity.removeComponent(43);
    Companion_instance_1.buildAssembly(entity, new AssemblyPart(productRef, VOID, VOID, structure.parts), parts.i1l_1, $this, $this.j2u_1, assemblyEntityIds);
  }
  function buildHierarchy($this, specification, entity) {
    var tmp0_elvis_lhs = specification._findComponentKt(Companion_instance_2.id);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return entity;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var structure = tmp;
    var newRoot = Companion_getInstance_0().buildProductStructure(structure, $this, $this.j2u_1);
    if (!equals(newRoot, entity)) {
      $this.j2u_1.disposeEntity(entity);
    }
    return newRoot;
  }
  function addComponent($this, entity, component) {
    if (component == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.catalog.ProductManagerImpl.addComponent.<anonymous>' call
      $this.j2u_1.addComponent(entity, component);
    }
  }
  function addComponents($this, entity, components) {
    if (components == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = components.length;
      while (inductionVariable < last) {
        var element = components[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.catalog.ProductManagerImpl.addComponents.<anonymous>' call
        $this.j2u_1.addComponent(entity, element);
      }
    }
  }
  function Companion() {
    Companion_instance_5 = this;
    this.logger = LoggerState_getInstance().m1m('ProductManagerImpl');
  }
  protoOf(Companion).x1i = function () {
    return this.logger;
  };
  var Companion_instance_5;
  function Companion_getInstance_8() {
    if (Companion_instance_5 == null)
      new Companion();
    return Companion_instance_5;
  }
  function ProductManagerImpl$createEntityInternal$lambda($productRef, this$0) {
    return function () {
      return 'Product ' + $productRef + ' not recognized by any catalog. Catalogs: ' + this$0.catalogs;
    };
  }
  function ProductManagerImpl$findProductSpecification$lambda($productRef) {
    return function (catalog) {
      return catalog.productSpecification($productRef);
    };
  }
  function ProductManagerImpl(entityManager, _defaultParent) {
    Companion_getInstance_8();
    this.j2u_1 = entityManager;
    this.k2u_1 = _defaultParent;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.l2u_1 = ArrayList_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.m2u_1 = ArrayList_init_$Create$();
  }
  protoOf(ProductManagerImpl).d1m = function () {
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = this.l2u_1;
    return copyToArray(this_0);
  };
  protoOf(ProductManagerImpl).defaultParent = function () {
    return this.k2u_1();
  };
  protoOf(ProductManagerImpl).addCatalog = function (catalog) {
    if (!catalog.thisClassIsGuaranteedToNotModifyOrQueryCoreState) {
      // Inline function 'kotlin.error' call
      var message = "You haven't read and accepted the class documentation for ProductCatalog for catalog with id: " + catalog.rangeId();
      throw IllegalStateException_init_$Create$(toString(message));
    }
    this.l2u_1.w1(0, catalog);
  };
  protoOf(ProductManagerImpl).removeCatalog = function (catalog) {
    this.l2u_1.r(catalog);
  };
  protoOf(ProductManagerImpl).e1m = function (productRef, entityId, parent) {
    var entity = this.createEntityInternal(productRef, entityId, parent);
    if (entity == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp0_iterator = this.m2u_1.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.catalog.ProductManagerImpl.createEntity.<anonymous>.<anonymous>' call
        element(entity, productRef);
      }
    }
    return entity;
  };
  protoOf(ProductManagerImpl).f1m = function (productRef, entityId, parent) {
    var specification = findProductSpecification(this, productRef);
    if (specification == null) {
      var tmp = Companion_getInstance_8().logger;
      tmp.warn(ProductManagerImpl$createEntityInternal$lambda(productRef, this));
      return null;
    }
    var entity = createEntityFromSpecification(this, specification, productRef, entityId);
    if (!(entity == null) ? !(parent == null) : false) {
      entity.addComponent(new ChildComponent(parent));
    }
    return entity;
  };
  protoOf(ProductManagerImpl).notifyCreatedListeners = function (entity) {
    var tmp0_safe_receiver = get_productRef(entity);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp0_iterator = this.m2u_1.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.catalog.ProductManagerImpl.notifyCreatedListeners.<anonymous>.<anonymous>' call
        element(entity, tmp0_safe_receiver);
      }
    }
  };
  protoOf(ProductManagerImpl).subscribeProductCreated = function (callback) {
    this.m2u_1.q(callback);
  };
  protoOf(ProductManagerImpl).unsubscribeProductCreated = function (callback) {
    this.m2u_1.r(callback);
  };
  protoOf(ProductManagerImpl).productSpecification = function (productRef) {
    return findProductSpecification(this, productRef);
  };
  protoOf(ProductManagerImpl).g1m = function (productRef, specification, entityId) {
    var entity = this.createFromSpecificationInternal(productRef, specification, entityId);
    if (entity == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp0_iterator = this.m2u_1.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.catalog.ProductManagerImpl.createFromSpecification.<anonymous>.<anonymous>' call
        element(entity, productRef);
      }
    }
    return entity;
  };
  protoOf(ProductManagerImpl).h1m = function (productRef, specification, entityId) {
    return createEntityFromSpecification(this, specification, productRef, entityId);
  };
  function printMe($this, listener, depth) {
    var indent = repeat(' ', depth);
    if (depth > 20) {
      var tmp = Companion_getInstance_9().n2u_1;
      tmp.info(SystemGraphViewer$printMe$lambda(indent));
    } else {
      printMe$innerPrint(indent, listener, listener.componentId);
      var tmp0_safe_receiver = listener.ownerSystem;
      printMe$traverseOuter($this, listener, depth, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.doingChangesOnComponent);
    }
  }
  function Companion_0() {
    Companion_instance_6 = this;
    this.n2u_1 = LoggerState_getInstance().m1m('SystemGraphViewer');
  }
  var Companion_instance_6;
  function Companion_getInstance_9() {
    if (Companion_instance_6 == null)
      new Companion_0();
    return Companion_instance_6;
  }
  function printMe$innerPrint(indent, $listener, listeningOn) {
    var s = {_v: ''};
    var tmp = s._v;
    var tmp0_safe_receiver = $listener.ownerSystem;
    s._v = tmp + (indent + (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.id) + ' (' + ComponentIds_instance.debugToString(listeningOn) + ') ');
    var tmp1_safe_receiver = $listener.ownerSystem;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.systemsBeforeMe;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp2_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp2_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.entity.SystemGraphViewer.printMe.innerPrint.<anonymous>' call
        s._v = s._v + (' beforeme: ' + element);
      }
    }
    var tmp3_safe_receiver = $listener.ownerSystem;
    var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.systemsAfterMe;
    if (tmp4_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_0 = 0;
      var last_0 = tmp4_safe_receiver.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = tmp4_safe_receiver[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.entity.SystemGraphViewer.printMe.innerPrint.<anonymous>' call
        s._v = s._v + (' afterme: ' + element_0);
      }
    }
    var tmp_0 = Companion_getInstance_9().n2u_1;
    tmp_0.info(SystemGraphViewer$printMe$innerPrint$lambda(s));
  }
  function printMe$traverseOuter(this$0, $listener, $depth, outgoingComponents) {
    if (outgoingComponents == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = outgoingComponents.length;
      while (inductionVariable < last) {
        var element = outgoingComponents[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.entity.SystemGraphViewer.printMe.traverseOuter.<anonymous>' call
        var tmp0_safe_receiver = this$0.o2u_1.allListeners().b3(element);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var inductionVariable_0 = 0;
          var last_0 = tmp0_safe_receiver.length;
          while (inductionVariable_0 < last_0) {
            var element_0 = tmp0_safe_receiver[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'com.ikea.core.entity.SystemGraphViewer.printMe.traverseOuter.<anonymous>.<anonymous>.<anonymous>' call
            var tmp0_safe_receiver_0 = element_0.ownerSystem;
            var tmp = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.id;
            var tmp1_safe_receiver = $listener.ownerSystem;
            if (!(tmp == (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.id))) {
              printMe(this$0, element_0, $depth + 4 | 0);
            }
          }
        }
      }
    }
  }
  function SystemGraphViewer$printFor$lambda($componentId) {
    return function () {
      return 'No systems are listening for ' + $componentId;
    };
  }
  function SystemGraphViewer$printMe$lambda($indent) {
    return function () {
      return $indent + ' stopping here. Too deep';
    };
  }
  function SystemGraphViewer$printMe$innerPrint$lambda($s) {
    return function () {
      return $s._v;
    };
  }
  function SystemGraphViewer(em) {
    Companion_getInstance_9();
    this.o2u_1 = em;
  }
  protoOf(SystemGraphViewer).printFor = function (componentId) {
    var all = this.o2u_1.allListeners();
    var base = all.b3(componentId);
    var tmp;
    if (base == null) {
      tmp = true;
    } else {
      // Inline function 'kotlin.collections.isEmpty' call
      tmp = base.length === 0;
    }
    if (tmp) {
      var tmp_0 = Companion_getInstance_9().n2u_1;
      tmp_0.info(SystemGraphViewer$printFor$lambda(componentId));
    } else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = base.length;
      while (inductionVariable < last) {
        var element = base[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.entity.SystemGraphViewer.printFor.<anonymous>' call
        printMe(this, element, 0);
      }
    }
  };
  function Companion_1() {
    this.ID = 'SceneManagerCacheSystem';
  }
  protoOf(Companion_1).u1n = function () {
    return this.ID;
  };
  var Companion_instance_7;
  function Companion_getInstance_10() {
    return Companion_instance_7;
  }
  function SceneManagerCacheClearingSystem(clearCallback) {
    var tmp = InSceneComponent_instance.id;
    SystemBase2.call(this, 'SceneManagerCacheSystem', tmp, 123);
    this.x2u_1 = clearCallback;
  }
  protoOf(SceneManagerCacheClearingSystem).onAddComponent = function (entity, newComponent) {
    this.x2u_1();
  };
  protoOf(SceneManagerCacheClearingSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
  };
  protoOf(SceneManagerCacheClearingSystem).onRemoveComponent = function (entity, oldComponent) {
    this.x2u_1();
  };
  protoOf(SceneManagerCacheClearingSystem).onAddComponent2 = function (entity, newComponent) {
    this.x2u_1();
  };
  protoOf(SceneManagerCacheClearingSystem).onUpdateComponent2 = function (entity, oldComponent, newComponent) {
  };
  protoOf(SceneManagerCacheClearingSystem).onRemoveComponent2 = function (entity, oldComponent) {
  };
  function Companion_2() {
  }
  protoOf(Companion_2).s1k = function () {
    return 117;
  };
  var Companion_instance_8;
  function Companion_getInstance_11() {
    return Companion_instance_8;
  }
  function SceneManagerCacheComponent(entitiesInScene) {
    this.entitiesInScene = entitiesInScene;
    this.y2u_1 = false;
  }
  protoOf(SceneManagerCacheComponent).z2u = function () {
    return this.entitiesInScene;
  };
  protoOf(SceneManagerCacheComponent).x1k = function () {
    return Companion_instance_8.id;
  };
  protoOf(SceneManagerCacheComponent).eq = function (other) {
    return false;
  };
  protoOf(SceneManagerCacheComponent).a1l = function () {
    return this.y2u_1;
  };
  protoOf(SceneManagerCacheComponent).af = function () {
    return this.entitiesInScene;
  };
  protoOf(SceneManagerCacheComponent).v29 = function (entitiesInScene) {
    return new SceneManagerCacheComponent(entitiesInScene);
  };
  protoOf(SceneManagerCacheComponent).copy = function (entitiesInScene, $super) {
    entitiesInScene = entitiesInScene === VOID ? this.entitiesInScene : entitiesInScene;
    return this.v29(entitiesInScene);
  };
  protoOf(SceneManagerCacheComponent).toString = function () {
    return 'SceneManagerCacheComponent(entitiesInScene=' + toString(this.entitiesInScene) + ')';
  };
  protoOf(SceneManagerCacheComponent).hashCode = function () {
    return hashCode(this.entitiesInScene);
  };
  protoOf(SceneManagerCacheComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SceneManagerCacheComponent))
      return false;
    var tmp0_other_with_cast = other instanceof SceneManagerCacheComponent ? other : THROW_CCE();
    if (!equals(this.entitiesInScene, tmp0_other_with_cast.entitiesInScene))
      return false;
    return true;
  };
  function SceneManagerEntitiesCache$clearCache$ref($boundThis) {
    var l = function () {
      $boundThis.clearCache();
      return Unit_instance;
    };
    l.callableName = 'clearCache';
    return l;
  }
  function SceneManagerEntitiesCache(holderEntity, entityManager) {
    this.a2v_1 = holderEntity;
    var tmp = this;
    tmp.b2v_1 = new SceneManagerCacheClearingSystem(SceneManagerEntitiesCache$clearCache$ref(this));
    this.b2v_1.register(entityManager);
    this.b2v_1.enable();
  }
  protoOf(SceneManagerEntitiesCache).getOrSet = function (newValue) {
    var cache = this.a2v_1.__getComponentForKotlin(Companion_instance_8.id);
    var tmp;
    if (cache == null) {
      var entitiesInScene = newValue();
      this.a2v_1.addComponentInternal(new SceneManagerCacheComponent(entitiesInScene));
      tmp = entitiesInScene;
    } else {
      tmp = cache.entitiesInScene;
    }
    return tmp;
  };
  protoOf(SceneManagerEntitiesCache).clearCache = function () {
    this.a2v_1.removeComponentInternal(Companion_instance_8.id);
  };
  function getFromCacheOrHierarchy($this) {
    return $this.f2v_1.getOrSet(SceneManagerImpl$getFromCacheOrHierarchy$lambda($this));
  }
  function replaceScene($this, newScene) {
    if (!$this.d2v_1.isDisposed) {
      $this.c2v_1.disposeEntity($this.d2v_1);
    }
    $this.d2v_1 = newScene;
  }
  function createSpace($this, name) {
    var space = $this.c2v_1.createEntity();
    space.addComponent(new DisplayNameComponent(name));
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    space.addComponent(new ParentComponent(tmp$ret$0));
    space.addComponent(StaticComponent_getInstance());
    return space;
  }
  function loadSceneGraph($this, newRoot, bundle, coreServices) {
    var extractedRoots = (new JsonSerializer(coreServices.productManager)).deserializeToEntityHierarchies(bundle, coreServices);
    if (!(extractedRoots.length === 1))
      return Unit_instance;
    var extractedRoot = first(extractedRoots);
    var newScene = SceneSerializationUtil_instance.findSceneFromDeserializedEntityTrees(extractedRoots);
    if (newScene == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      HierarchyUtils_instance.setParent(newScene, newRoot);
      newScene.addComponent(SceneComponent_instance);
      newScene.addComponent(InSceneComponent_instance);
      newScene.addComponent(StaticComponent_getInstance());
      newScene.addComponent(new DisplayNameComponent('scene'));
      replaceScene($this, newScene);
    }
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = get_children(extractedRoot);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.hierarchies.SceneManagerImpl.loadSceneGraph.<anonymous>' call
      HierarchyUtils_instance.setParent(element, newRoot);
    }
    var tmp1_safe_receiver = get_parentComponent(newRoot);
    var rootChildren = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.children;
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject_0 = get_hierarchy($this.scene);
    var inductionVariable_0 = 0;
    var last_0 = indexedObject_0.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = indexedObject_0[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.hierarchies.SceneManagerImpl.loadSceneGraph.<anonymous>' call
      element_0.addComponent(InSceneComponent_instance);
    }
    var tmp;
    if (rootChildren == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.count' call
      var count = 0;
      var inductionVariable_1 = 0;
      var last_1 = rootChildren.length;
      while (inductionVariable_1 < last_1) {
        var element_1 = rootChildren[inductionVariable_1];
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'com.ikea.core.hierarchies.SceneManagerImpl.loadSceneGraph.<anonymous>' call
        if (element_1.hasComponent(SceneComponent_instance.id)) {
          count = count + 1 | 0;
        }
      }
      tmp = count;
    }
    var tmp3_elvis_lhs = tmp;
    var numScenes = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
    if (numScenes > 1) {
      var tmp_0 = Companion_getInstance_12().g2v_1;
      tmp_0.error(SceneManagerImpl$loadSceneGraph$lambda(numScenes));
    }
    if (numScenes === 0) {
      var tmp_1 = Companion_getInstance_12().g2v_1;
      tmp_1.error(SceneManagerImpl$loadSceneGraph$lambda_0);
    }
  }
  function Companion_3() {
    Companion_instance_9 = this;
    this.g2v_1 = LoggerState_getInstance().m1m('SceneGraphImpl');
  }
  var Companion_instance_9;
  function Companion_getInstance_12() {
    if (Companion_instance_9 == null)
      new Companion_3();
    return Companion_instance_9;
  }
  function SceneManagerImpl$getFromCacheOrHierarchy$lambda(this$0) {
    return function () {
      return get_hierarchy(this$0.d2v_1);
    };
  }
  function SceneManagerImpl$loadSceneGraph$lambda($numScenes) {
    return function () {
      return 'found ' + $numScenes + ' scenes, that is most probably an error';
    };
  }
  function SceneManagerImpl$loadSceneGraph$lambda_0() {
    return 'Could not find a scene in deserialized json';
  }
  function SceneManagerImpl(entityManager) {
    Companion_getInstance_12();
    this.c2v_1 = entityManager;
    this.e2v_1 = createSpace(this, 'root');
    this.f2v_1 = new SceneManagerEntitiesCache(this.e2v_1, this.c2v_1);
    var newScene = createSpace(this, 'scene');
    newScene.addComponent(SceneComponent_instance);
    newScene.addComponent(InSceneComponent_instance);
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.hierarchies.SceneManagerImpl.<anonymous>' call
    var spaceRot = this.e2v_1;
    var tmp0_safe_receiver = get_parentComponent(spaceRot);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.addChild(newScene);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = [newScene];
      tmp = new ParentComponent(tmp$ret$2);
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var newParentComponent = tmp;
    spaceRot.addComponent(newParentComponent);
    newScene.addComponent(new ChildComponent(spaceRot));
    this.d2v_1 = newScene;
  }
  protoOf(SceneManagerImpl).o24 = function () {
    return getFromCacheOrHierarchy(this);
  };
  protoOf(SceneManagerImpl).e2a = function () {
    return this.d2v_1;
  };
  protoOf(SceneManagerImpl).f2a = function () {
    return this.e2v_1;
  };
  protoOf(SceneManagerImpl).save = function (coreServices) {
    var tempRoot = this.c2v_1.createEntity();
    HierarchyUtils_instance.setParent(this.d2v_1, tempRoot);
    try {
      return coreServices.serializer.toJsonString(tempRoot);
    }finally {
      HierarchyUtils_instance.setParent(this.scene, this.e2v_1);
      this.c2v_1.disposeEntity(tempRoot);
    }
  };
  protoOf(SceneManagerImpl).load = function (bundle, coreServices) {
    this.f2v_1.clearCache();
    var tmp0_safe_receiver = coreServices.coreModules.history();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.clear();
    }
    this.e2v_1.addComponent(SceneReloadingComponent_instance);
    this.clearScene();
    loadSceneGraph(this, this.e2v_1, bundle, coreServices);
    this.e2v_1.removeComponent(SceneReloadingComponent_instance.id);
  };
  protoOf(SceneManagerImpl).clearScene = function () {
    this.f2v_1.clearCache();
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = get_children(this.scene);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.hierarchies.SceneManagerImpl.clearScene.<anonymous>' call
      this.c2v_1.disposeEntity(element);
    }
  };
  protoOf(SceneManagerImpl).findEntity = function (id) {
    if (id === this.e2v_1.id)
      return this.e2v_1;
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var space = this.scene;
    if (id === space.id)
      return space;
    var tmp0_safe_receiver = get_parentComponent(space);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.allDescendants();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.find' call
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var inductionVariable = 0;
        var last = tmp1_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp1_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.hierarchies.SceneManagerImpl.findEntity.<anonymous>.<anonymous>' call
          if (element.id === id) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      tmp = tmp$ret$1;
    }
    return tmp;
  };
  function SceneSerializationUtil() {
  }
  protoOf(SceneSerializationUtil).findSceneFromDeserializedEntityTrees = function (roots) {
    var tmp0_elvis_lhs = firstOrNull_0(roots);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var root = tmp;
    var children = get_children(root);
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = children.length;
      while (inductionVariable < last) {
        var element = children[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.hierarchies.SceneSerializationUtil.findSceneFromDeserializedEntityTrees.<anonymous>' call
        if (element.hasComponent(SceneComponent_instance.id)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var entityWithSceneComponent = tmp$ret$1;
    if (!(entityWithSceneComponent == null))
      return entityWithSceneComponent;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable_0 = 0;
    var last_0 = children.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = children[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.hierarchies.SceneSerializationUtil.findSceneFromDeserializedEntityTrees.<anonymous>' call
      if (!element_0.hasComponent(18)) {
        destination.q(element_0);
      }
    }
    var nonProductChildren = destination;
    if (nonProductChildren.n() === 1)
      return first_0(nonProductChildren);
    // Inline function 'kotlin.collections.find' call
    var this_0 = get_hierarchy(root);
    var tmp$ret$7;
    $l$block_0: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable_1 = 0;
      var last_1 = this_0.length;
      while (inductionVariable_1 < last_1) {
        var element_1 = this_0[inductionVariable_1];
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'com.ikea.core.hierarchies.SceneSerializationUtil.findSceneFromDeserializedEntityTrees.<anonymous>' call
        var tmp_0;
        var tmp_1;
        if (element_1.hasComponent(53)) {
          tmp_1 = true;
        } else {
          tmp_1 = element_1.hasComponent(41);
        }
        if (tmp_1) {
          tmp_0 = true;
        } else {
          tmp_0 = element_1.hasComponent(70);
        }
        if (tmp_0) {
          tmp$ret$7 = element_1;
          break $l$block_0;
        }
      }
      tmp$ret$7 = null;
    }
    var room = tmp$ret$7;
    var roomParent = room == null ? null : get_parent(room);
    if (!(roomParent == null))
      return roomParent;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator = nonProductChildren.t();
    while (tmp0_iterator.u()) {
      var element_2 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.hierarchies.SceneSerializationUtil.findSceneFromDeserializedEntityTrees.<anonymous>' call
      var tmp$ret$10;
      $l$block_1: {
        // Inline function 'kotlin.collections.any' call
        var indexedObject = get_descendants(element_2);
        var inductionVariable_2 = 0;
        var last_2 = indexedObject.length;
        while (inductionVariable_2 < last_2) {
          var element_3 = indexedObject[inductionVariable_2];
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          // Inline function 'com.ikea.core.hierarchies.SceneSerializationUtil.findSceneFromDeserializedEntityTrees.<anonymous>.<anonymous>' call
          if (element_3.hasComponent(18)) {
            tmp$ret$10 = true;
            break $l$block_1;
          }
        }
        tmp$ret$10 = false;
      }
      if (tmp$ret$10) {
        destination_0.q(element_2);
      }
    }
    var nonProductChildrenWithProductDescendants = destination_0;
    if (nonProductChildrenWithProductDescendants.n() === 1)
      return first_0(nonProductChildrenWithProductDescendants);
    if (nonProductChildrenWithProductDescendants.n() > 1)
      return null;
    return null;
  };
  var SceneSerializationUtil_instance;
  function SceneSerializationUtil_getInstance() {
    return SceneSerializationUtil_instance;
  }
  function localTransformationComponent($this, json) {
    return Companion_getInstance_1().fromJson(json);
  }
  function worldTransformationComponent($this, json) {
    return Companion_getInstance_2().fromJson(json);
  }
  function assemblyPartsComponent($this, json) {
    return Companion_getInstance().f1l(json);
  }
  function automaticGroupComponent($this, json) {
    return Companion_getInstance_3().fromJson();
  }
  function manualGroupComponent($this, json) {
    return Companion_getInstance_4().fromJson();
  }
  function productPartComponent($this, json) {
    return Companion_getInstance_5().fromJson(json);
  }
  function serializableGuestConnectionsComponent($this, json) {
    return Companion_getInstance_6().fromJson(json);
  }
  function CoreComponentDeserializer$localTransformationComponent$ref($boundThis) {
    var l = function (p0) {
      return localTransformationComponent($boundThis, p0);
    };
    l.callableName = 'localTransformationComponent';
    return l;
  }
  function CoreComponentDeserializer$worldTransformationComponent$ref($boundThis) {
    var l = function (p0) {
      return worldTransformationComponent($boundThis, p0);
    };
    l.callableName = 'worldTransformationComponent';
    return l;
  }
  function CoreComponentDeserializer$automaticGroupComponent$ref($boundThis) {
    var l = function (p0) {
      return automaticGroupComponent($boundThis, p0);
    };
    l.callableName = 'automaticGroupComponent';
    return l;
  }
  function CoreComponentDeserializer$manualGroupComponent$ref($boundThis) {
    var l = function (p0) {
      return manualGroupComponent($boundThis, p0);
    };
    l.callableName = 'manualGroupComponent';
    return l;
  }
  function CoreComponentDeserializer$assemblyPartsComponent$ref($boundThis) {
    var l = function (p0) {
      return assemblyPartsComponent($boundThis, p0);
    };
    l.callableName = 'assemblyPartsComponent';
    return l;
  }
  function CoreComponentDeserializer$productPartComponent$ref($boundThis) {
    var l = function (p0) {
      return productPartComponent($boundThis, p0);
    };
    l.callableName = 'productPartComponent';
    return l;
  }
  function CoreComponentDeserializer$serializableGuestConnectionsComponent$ref($boundThis) {
    var l = function (p0) {
      return serializableGuestConnectionsComponent($boundThis, p0);
    };
    l.callableName = 'serializableGuestConnectionsComponent';
    return l;
  }
  function CoreComponentDeserializer() {
    this.h2v_1 = true;
    var tmp = this;
    Companion_getInstance_1();
    var tmp_0 = to('LocalTransformComponent', CoreComponentDeserializer$localTransformationComponent$ref(this));
    Companion_getInstance_2();
    var tmp_1 = to('WorldTransformComponent', CoreComponentDeserializer$worldTransformationComponent$ref(this));
    Companion_getInstance_3();
    var tmp_2 = to('EntityGroupParentComponent', CoreComponentDeserializer$automaticGroupComponent$ref(this));
    Companion_getInstance_4();
    var tmp_3 = to('ManualGroupComponent', CoreComponentDeserializer$manualGroupComponent$ref(this));
    Companion_getInstance();
    var tmp_4 = to('AssemblyPartsComponent', CoreComponentDeserializer$assemblyPartsComponent$ref(this));
    Companion_getInstance_5();
    var tmp_5 = to('ProductPartComponent', CoreComponentDeserializer$productPartComponent$ref(this));
    Companion_getInstance_6();
    tmp.i2v_1 = mapOf([tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, to('Connections', CoreComponentDeserializer$serializableGuestConnectionsComponent$ref(this))]);
  }
  protoOf(CoreComponentDeserializer).a1m = function () {
    return this.h2v_1;
  };
  protoOf(CoreComponentDeserializer).canHandle = function (serializationKey) {
    return this.i2v_1.y2(serializationKey);
  };
  protoOf(CoreComponentDeserializer).deserialize = function (serializationKey, json) {
    var tmp0_elvis_lhs = this.i2v_1.b3(serializationKey);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$(toString(''));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp(json);
  };
  function validateAndCollectResults($this, entity, earlyOut) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.mapIndexed' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = $this.j2v_1;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.system.ValidationServiceImpl.validateAndCollectResults.<anonymous>' call
      if (element.isEnabled) {
        destination.q(element);
      }
    }
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
    var index = 0;
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var item = tmp0_iterator.w();
      // Inline function 'com.ikea.core.system.ValidationServiceImpl.validateAndCollectResults.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var i = checkIndexOverflow(tmp1);
      var id$delegate = lazy(ValidationServiceImpl$validateAndCollectResults$lambda(i, item));
      var tmp0_safe_receiver = $this.k2v_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.start(validateAndCollectResults$_anonymous_$lambda$0_ahocsf(id$delegate));
      }
      var result = item.validateCurrentState(entity);
      var tmp1_safe_receiver = $this.k2v_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.stop(validateAndCollectResults$_anonymous_$lambda$0_ahocsf(id$delegate));
      }
      var tmp;
      if (earlyOut) {
        tmp = equals(result == null ? null : result.resultType, ValidationResultType_FAIL_getInstance());
      } else {
        tmp = false;
      }
      if (tmp) {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [result];
      }
      destination_0.q(result);
    }
    var this_1 = filterNotNull(destination_0);
    var results = copyToArray(this_1);
    var tmp_0;
    // Inline function 'kotlin.collections.isEmpty' call
    if (results.length === 0) {
      tmp_0 = $this.l2v_1;
    } else {
      tmp_0 = results;
    }
    return tmp_0;
  }
  function validateAndCollectResults_0($this, snapActionCandidate, earlyOut) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.mapIndexed' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = $this.j2v_1;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.system.ValidationServiceImpl.validateAndCollectResults.<anonymous>' call
      if (element.isEnabled) {
        destination.q(element);
      }
    }
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
    var index = 0;
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var item = tmp0_iterator.w();
      // Inline function 'com.ikea.core.system.ValidationServiceImpl.validateAndCollectResults.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var i = checkIndexOverflow(tmp1);
      var id$delegate = lazy(ValidationServiceImpl$validateAndCollectResults$lambda_0(i, item));
      var tmp0_safe_receiver = $this.k2v_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.start(validateAndCollectResults$_anonymous_$lambda$1_ahocse(id$delegate));
      }
      var result = item.validateSnap(snapActionCandidate);
      var tmp1_safe_receiver = $this.k2v_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.stop(validateAndCollectResults$_anonymous_$lambda$1_ahocse(id$delegate));
      }
      var tmp;
      if (earlyOut) {
        tmp = equals(result == null ? null : result.resultType, ValidationResultType_FAIL_getInstance());
      } else {
        tmp = false;
      }
      if (tmp) {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [result];
      }
      destination_0.q(result);
    }
    var this_1 = filterNotNull(destination_0);
    var results = copyToArray(this_1);
    var tmp_0;
    // Inline function 'kotlin.collections.isEmpty' call
    if (results.length === 0) {
      tmp_0 = $this.l2v_1;
    } else {
      tmp_0 = results;
    }
    return tmp_0;
  }
  function hasNoErrorsInResult($this, results) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var inductionVariable = 0;
      var last = results.length;
      while (inductionVariable < last) {
        var element = results[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.system.ValidationServiceImpl.hasNoErrorsInResult.<anonymous>' call
        if (element.resultType.equals(ValidationResultType_FAIL_getInstance())) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return !tmp$ret$1;
  }
  function validateAndCollectResults$_anonymous_$lambda$0_ahocsf($id$delegate) {
    // Inline function 'kotlin.getValue' call
    getLocalDelegateReference('id', KProperty0, false, function () {
      return THROW_ISE();
    });
    return $id$delegate.u2();
  }
  function validateAndCollectResults$_anonymous_$lambda$1_ahocse($id$delegate) {
    // Inline function 'kotlin.getValue' call
    getLocalDelegateReference('id', KProperty0, false, function () {
      return THROW_ISE();
    });
    return $id$delegate.u2();
  }
  function ValidationServiceImpl$validateAndCollectResults$lambda($i, $rule) {
    return function () {
      return '' + $i + '. ' + $rule.id;
    };
  }
  function ValidationServiceImpl$validateAndCollectResults$lambda_0($i, $rule) {
    return function () {
      return '' + $i + '. ' + $rule.id;
    };
  }
  function ValidationServiceImpl() {
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    tmp.j2v_1 = [];
    this.k2v_1 = null;
    var tmp_0 = this;
    // Inline function 'kotlin.emptyArray' call
    tmp_0.l2v_1 = [];
  }
  protoOf(ValidationServiceImpl).i2t = function (_set____db54di) {
    this.k2v_1 = _set____db54di;
  };
  protoOf(ValidationServiceImpl).j2t = function () {
    return this.k2v_1;
  };
  protoOf(ValidationServiceImpl).s1i = function () {
    return this.j2v_1;
  };
  protoOf(ValidationServiceImpl).register = function (validation) {
    var tmp = this;
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = this.j2v_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [validation];
    tmp.j2v_1 = tmp$ret$0.concat(tmp$ret$3);
  };
  protoOf(ValidationServiceImpl).unregister = function (validation) {
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = minus(toMutableList(this.j2v_1), validation);
    tmp.j2v_1 = copyToArray(this_0);
  };
  protoOf(ValidationServiceImpl).b2u = function (snapActionCandidate, earlyOut) {
    snapActionCandidate.perform();
    var result = validateAndCollectResults_0(this, snapActionCandidate, earlyOut);
    snapActionCandidate.rollback();
    return result;
  };
  protoOf(ValidationServiceImpl).c2u = function (snapActionCandidates, earlyOut) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = snapActionCandidates.length;
    while (inductionVariable < last) {
      var element = snapActionCandidates[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.system.ValidationServiceImpl.validateSnaps.<anonymous>' call
      var list = toList(this.validateSnap(element, earlyOut));
      addAll(destination, list);
    }
    return copyToArray(destination);
  };
  protoOf(ValidationServiceImpl).a2u = function (entity, earlyOut) {
    return validateAndCollectResults(this, entity, earlyOut);
  };
  protoOf(ValidationServiceImpl).d2u = function (snapActionCandidates, sortByWarnings) {
    // Inline function 'kotlin.emptyArray' call
    var allErrors = [];
    var firstWarning = null;
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = snapActionCandidates.length;
    while (inductionVariable < last) {
      var element = snapActionCandidates[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.system.ValidationServiceImpl.getFirstValidSnapAction.<anonymous>' call
      element.perform();
      var errorsAndWarnings = validateAndCollectResults_0(this, element, true);
      // Inline function 'kotlin.collections.isEmpty' call
      var snapWasGood = errorsAndWarnings.length === 0;
      if (snapWasGood) {
        element.rollback();
        return new ValidSnapActionCandidateOrErrors(element);
      }
      var snapWasOk = hasNoErrorsInResult(this, errorsAndWarnings);
      if (snapWasOk) {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList_init_$Create$();
        var inductionVariable_0 = 0;
        var last_0 = errorsAndWarnings.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = errorsAndWarnings[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.core.system.ValidationServiceImpl.getFirstValidSnapAction.<anonymous>.<anonymous>' call
          if (element_0.resultType.equals(ValidationResultType_WARNING_getInstance())) {
            destination.q(element_0);
          }
        }
        var myWarnings = destination;
        var tmp;
        if (firstWarning == null) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.count' call
          tmp = ensureNotNull(firstWarning).warnings.length > myWarnings.n();
        }
        if (tmp) {
          if (sortByWarnings) {
            // Inline function 'kotlin.collections.toTypedArray' call
            var tmp$ret$6 = copyToArray(myWarnings);
            firstWarning = new ValidSnapActionCandidateOrErrors(element, tmp$ret$6);
          } else {
            // Inline function 'kotlin.collections.toTypedArray' call
            var tmp$ret$7 = copyToArray(myWarnings);
            return new ValidSnapActionCandidateOrErrors(element, tmp$ret$7);
          }
        }
      }
      // Inline function 'kotlin.collections.plus' call
      // Inline function 'kotlin.js.asDynamic' call
      allErrors = allErrors.concat(errorsAndWarnings);
    }
    var tmp0_safe_receiver = lastOrNull(snapActionCandidates);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.rollback();
    }
    var tmp1_elvis_lhs = firstWarning;
    return tmp1_elvis_lhs == null ? new ValidSnapActionCandidateOrErrors(null, VOID, allErrors) : tmp1_elvis_lhs;
  };
  protoOf(ValidationServiceImpl).e2u = function (snapActionCandidate, earlyOut) {
    var validationResult = this.validateSnap(snapActionCandidate, earlyOut);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.all' call
      var inductionVariable = 0;
      var last = validationResult.length;
      while (inductionVariable < last) {
        var element = validationResult[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.system.ValidationServiceImpl.evaluateSnapCandidate.<anonymous>' call
        if (!!element.resultType.equals(ValidationResultType_FAIL_getInstance())) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
      tmp$ret$1 = true;
    }
    var wasValid = tmp$ret$1;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable_0 = 0;
    var last_0 = validationResult.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = validationResult[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.system.ValidationServiceImpl.evaluateSnapCandidate.<anonymous>' call
      if (element_0.resultType.equals(ValidationResultType_WARNING_getInstance())) {
        destination.q(element_0);
      }
    }
    var warnings = copyToArray(destination);
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var inductionVariable_1 = 0;
    var last_1 = validationResult.length;
    while (inductionVariable_1 < last_1) {
      var element_1 = validationResult[inductionVariable_1];
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      // Inline function 'com.ikea.core.system.ValidationServiceImpl.evaluateSnapCandidate.<anonymous>' call
      if (element_1.resultType.equals(ValidationResultType_FAIL_getInstance())) {
        destination_0.q(element_1);
      }
    }
    var errors = copyToArray(destination_0);
    var validCandidate = wasValid ? snapActionCandidate : null;
    var result = new ValidSnapActionCandidateOrErrors(validCandidate, warnings, errors);
    return result;
  };
  protoOf(ValidationServiceImpl).f2u = function (snapActionCandidates, earlyOut) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(snapActionCandidates.length);
    var inductionVariable = 0;
    var last = snapActionCandidates.length;
    while (inductionVariable < last) {
      var item = snapActionCandidates[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.system.ValidationServiceImpl.evaluateSnapCandidates.<anonymous>' call
      var tmp$ret$0 = this.evaluateSnapCandidate(item, earlyOut);
      destination.q(tmp$ret$0);
    }
    return copyToArray(destination);
  };
  function simulateClick(_this__u8e3s4, coreServices) {
    var event = new ClickEventComponent(Companion_getInstance_7().ZERO);
    coreServices.entityManager.addComponent(_this__u8e3s4, event);
    coreServices.entityManager.removeComponent(_this__u8e3s4, event.f2m_1);
  }
  //region block: post-declaration
  protoOf(CoreImpl).setLogModule = setLogModule;
  protoOf(CoreImpl).addHistoryModule = addHistoryModule;
  defineProp(protoOf(CoreImpl), 'services', function () {
    return this.m1i();
  });
  defineProp(protoOf(CoreImpl), 'modules', function () {
    return this.n1i();
  });
  protoOf(ProductManagerImpl).createEntity = createEntity;
  protoOf(ProductManagerImpl).createEntityInternal = createEntityInternal;
  protoOf(ProductManagerImpl).createFromSpecification = createFromSpecification;
  protoOf(ProductManagerImpl).createFromSpecificationInternal = createFromSpecificationInternal;
  defineProp(protoOf(ProductManagerImpl), 'catalogs', function () {
    return this.d1m();
  });
  defineProp(protoOf(Companion_2), 'id', protoOf(Companion_2).s1k);
  protoOf(SceneManagerCacheComponent).z1k = get_serializable;
  defineProp(protoOf(SceneManagerCacheComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(SceneManagerCacheComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(SceneManagerCacheComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(SceneManagerImpl), 'entities', function () {
    return this.o24();
  });
  defineProp(protoOf(SceneManagerImpl), 'scene', function () {
    return this.e2a();
  });
  defineProp(protoOf(SceneManagerImpl), 'root', function () {
    return this.f2a();
  });
  defineProp(protoOf(CoreComponentDeserializer), 'thisClassIsGuaranteedToNotModifyOrQueryCoreState', function () {
    return this.a1m();
  });
  protoOf(ValidationServiceImpl).validateSnap = validateSnap;
  protoOf(ValidationServiceImpl).validateSnaps = validateSnaps;
  protoOf(ValidationServiceImpl).validateCurrentState = validateCurrentState;
  protoOf(ValidationServiceImpl).getFirstValidSnapAction = getFirstValidSnapAction;
  protoOf(ValidationServiceImpl).evaluateSnapCandidate = evaluateSnapCandidate;
  protoOf(ValidationServiceImpl).evaluateSnapCandidates = evaluateSnapCandidates;
  defineProp(protoOf(ValidationServiceImpl), 'measurer', function () {
    return this.j2t();
  }, function (value) {
    this.i2t(value);
  });
  defineProp(protoOf(ValidationServiceImpl), 'validations', function () {
    return this.s1i();
  });
  //endregion
  //region block: init
  Companion_instance_7 = new Companion_1();
  Companion_instance_8 = new Companion_2();
  SceneSerializationUtil_instance = new SceneSerializationUtil();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    $com$ikea$core.CoreFactoryImpl = CoreFactoryImpl;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    $com$ikea$core.CoreImpl = CoreImpl;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    $com$ikea$core.CoreModulesImpl = CoreModulesImpl;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$catalog = $com$ikea$core.catalog || ($com$ikea$core.catalog = {});
    $com$ikea$core$catalog.ProductManagerImpl = ProductManagerImpl;
    $com$ikea$core$catalog.ProductManagerImpl.createEntityFromSpecification$default = createEntityFromSpecification$default;
    defineProp($com$ikea$core$catalog.ProductManagerImpl, 'Companion', Companion_getInstance_8);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$entity = $com$ikea$core.entity || ($com$ikea$core.entity = {});
    $com$ikea$core$entity.SystemGraphViewer = SystemGraphViewer;
    defineProp($com$ikea$core$entity.SystemGraphViewer, 'Companion', Companion_getInstance_9);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$hierarchies = $com$ikea$core.hierarchies || ($com$ikea$core.hierarchies = {});
    $com$ikea$core$hierarchies.SceneManagerCacheClearingSystem = SceneManagerCacheClearingSystem;
    defineProp($com$ikea$core$hierarchies.SceneManagerCacheClearingSystem, 'Companion', Companion_getInstance_10);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$hierarchies = $com$ikea$core.hierarchies || ($com$ikea$core.hierarchies = {});
    $com$ikea$core$hierarchies.SceneManagerCacheComponent = SceneManagerCacheComponent;
    defineProp($com$ikea$core$hierarchies.SceneManagerCacheComponent, 'Companion', Companion_getInstance_11);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$hierarchies = $com$ikea$core.hierarchies || ($com$ikea$core.hierarchies = {});
    $com$ikea$core$hierarchies.SceneManagerEntitiesCache = SceneManagerEntitiesCache;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$hierarchies = $com$ikea$core.hierarchies || ($com$ikea$core.hierarchies = {});
    $com$ikea$core$hierarchies.SceneManagerImpl = SceneManagerImpl;
    defineProp($com$ikea$core$hierarchies.SceneManagerImpl, 'Companion', Companion_getInstance_12);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$hierarchies = $com$ikea$core.hierarchies || ($com$ikea$core.hierarchies = {});
    defineProp($com$ikea$core$hierarchies, 'SceneSerializationUtil', SceneSerializationUtil_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$service = $com$ikea$core.service || ($com$ikea$core.service = {});
    $com$ikea$core$service.CoreComponentDeserializer = CoreComponentDeserializer;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$system = $com$ikea$core.system || ($com$ikea$core.system = {});
    $com$ikea$core$system.ValidationServiceImpl = ValidationServiceImpl;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$test = $com$ikea$core.test || ($com$ikea$core.test = {});
    $com$ikea$core$test.simulateClick = simulateClick;
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = CoreImpl;
  _.$_$.b = SceneSerializationUtil_instance;
  //endregion
  return _;
}));

//# sourceMappingURL=core-core-kernel.js.map
